import React, { useEffect } from 'react';
import { sound } from '../utils/sound';

type InfoPopupType = 'welcome' | 'lastDay';

interface InfoPopupProps {
  type: InfoPopupType;
  onContinue: () => void;
  isClosing?: boolean;
}

const InfoPopup: React.FC<InfoPopupProps> = ({ type, onContinue, isClosing = false }) => {
  // Play info window open sound on mount
  useEffect(() => {
    sound.infoWindowOpen();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        handleContinueClick();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onContinue]);

  const handleContinueClick = () => {
    sound.clickOpen();
    onContinue();
  };

  const content = {
    welcome: {
      title: 'Welcome to the AI Workshop!',
      message: 'This is a fun adventure designed to sharpen your AI skills through daily challenges. Complete tasks, earn stars, and unlock badges as you progress through this interactive calendar. Each day brings a new opportunity to learn and improve!',
    },
    lastDay: {
      title: '🌟 Congratulations! 🌟',
      message: 'Thank you for participating in our AI Workshop! This is the last day of the workshop, but the journey doesn\'t have to stop here - feel free to keep playing and improve your scores on previous days. Every resubmission is a chance to refine your skills!',
    },
  };

  const { title, message } = content[type];

  return (
    <>
      <div className={`info-popup-overlay ${isClosing ? 'closing' : ''}`} />
      <div className="info-popup-wrapper">
        <div className={`info-popup-content-wrapper ${isClosing ? 'closing' : ''}`}>
          <div className="info-popup-content">
            <div className="info-popup-header">
              <h2>{title}</h2>
            </div>
            <div className="info-popup-body">
              <p className="info-popup-message">{message}</p>
            </div>
          </div>
        </div>
        <button className={`info-popup-continue ${isClosing ? 'closing' : ''}`} onClick={handleContinueClick}>
          {type === 'welcome' ? 'Let\'s Begin!' : 'Continue Playing'}
        </button>
      </div>
    </>
  );
};

export default InfoPopup;
